import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import DatePicker from '../../Common/DatePicker/DatePicker';
import Toggle from '../../Common/Toggle/Toggle';
import { getDateValue } from '../../../helpers/reports';
import '../Reports.scss';


export class LocationListFilters extends React.Component {

    constructor(props, context) {
        super(props, context);

        const initialFormSelections = {
            isLocationActive: '',
            openingDateStart: '',
            openingDateEnd: '',
            createdDateStart: '',
            createdDateEnd: '',
            useReportDateForOpeningDateStart: false,
            useReportDateForOpeningDateEnd: false,
            useReportDateForCreatedDateStart: false,
            useReportDateForCreatedDateEnd: false
        }

        this.state = {
            emptyForm: initialFormSelections,
            isLocationActive: initialFormSelections.isLocationActive,
            locationStatusOptions: [{ id: '', name: 'All' }, { id: 'true', name: 'Active' }, { id: 'false', name: 'Inactive' }],
            openingDateStart: initialFormSelections.openingDateStart,
            openingDateEnd: initialFormSelections.openingDateEnd,
            createdDateStart: initialFormSelections.createdDateStart,
            createdDateEnd: initialFormSelections.createdDateEnd,
            useReportDateForOpeningDateStart: initialFormSelections.useReportDateForOpeningDateStart,
            useReportDateForOpeningDateEnd: initialFormSelections.useReportDateForOpeningDateEnd,
            useReportDateForCreatedDateStart: initialFormSelections.useReportDateForCreatedDateStart,
            useReportDateForCreatedDateEnd: initialFormSelections.useReportDateForCreatedDateEnd
        }
    }

    componentDidMount = async () => {
        /**
         * Must set defaults before registering report filter functions, because
         * these defaults might be overridden by mapToForm values coming from
         * the API when opening a scheduled report.
         */
        this.setDefaults();
        /**
         * On mount, register all of this form's callbacks so the parent is able
         * to use them when its wrapping UI indicates these actions should be
         * performed.
         */
        this.props.registerReportFilterFunctions(
            this.props.report.id,
            this.clearForm,
            this.validateForm,
            this.mapToForm,
            this.mapToApiRequest
        );
    }

    setDefaults = () => {
        let newState = { ...this.state };

        const appState = this.props.savedFilterValues;
        if (appState) {
            // Set new state to values from redux app state
            newState = {
                ...newState,
                isLocationActive: appState.isLocationActive ? appState.isLocationActive : newState.isLocationActive,
                openingDateStart: appState.openingDateStart ? appState.openingDateStart : newState.openingDateStart,
                openingDateEnd: appState.openingDateEnd ? appState.openingDateEnd : newState.openingDateEnd,
                createdDateStart: appState.createdDateStart ? appState.createdDateStart : newState.createdDateStart,
                createdDateEnd: appState.createdDateEnd ? appState.createdDateEnd : newState.createdDateEnd
            }
        }

        if (this.props.isSchedulingMode) {
            newState.useReportDateForOpeningDateStart = appState.useReportDateForOpeningDateStart ? true : newState.useReportDateForOpeningDateStart;
            newState.useReportDateForOpeningDateEnd = appState.useReportDateForOpeningDateEnd ? true : newState.useReportDateForOpeningDateEnd;
            newState.useReportDateForCreatedDateStart = appState.useReportDateForCreatedDateStart ? true : newState.useReportDateForCreatedDateStart;
            newState.useReportDateForCreatedDateEnd = appState.useReportDateForCreatedDateEnd ? true : newState.useReportDateForCreatedDateEnd;
        } else {
            newState.useReportDateForOpeningDateStart = false;
            newState.useReportDateForOpeningDateEnd = false;
            newState.useReportDateForCreatedDateStart = false;
            newState.useReportDateForCreatedDateEnd = false;
        }

        this.setState({
            ...this.state,
            ...newState
        });
    }

    clearForm = () => {
        this.setState({
            ...this.state,
            ...this.state.emptyForm
        });
    }

    validateForm = () => {
        return true;
    }

    mapToForm = (reportRequest) => {
        const form = { ...this.state.emptyForm };

        form.isLocationActive = (reportRequest.isLocationActive === true || reportRequest.isLocationActive === false) ? reportRequest.isLocationActive.toString() : form.isLocationActive;
        form.openingDateStart = getDateValue(reportRequest.openingDateStart);
        form.openingDateEnd = getDateValue(reportRequest.openingDateEnd);
        form.createdDateStart = getDateValue(reportRequest.createdDateStart);
        form.createdDateEnd = getDateValue(reportRequest.createdDateEnd);

        form.useReportDateForOpeningDateStart = (reportRequest.useReportDateForOpeningDateStart) ? true : form.useReportDateForOpeningDateStart;
        form.useReportDateForOpeningDateEnd = (reportRequest.useReportDateForOpeningDateEnd) ? true : form.useReportDateForOpeningDateEnd;
        form.useReportDateForCreatedDateStart = (reportRequest.useReportDateForCreatedDateStart) ? true : form.useReportDateForCreatedDateStart;
        form.useReportDateForCreatedDateEnd = (reportRequest.useReportDateForCreatedDateEnd) ? true : form.useReportDateForCreatedDateEnd;

        this.setState({
            ...this.state,
            ...form
        });
    }

    mapToApiRequest = () => {
        const request = {
            reportId: this.props.report.id,
            isLocationActive: this.state.isLocationActive,
            openingDateStart: this.state.openingDateStart,
            openingDateEnd: this.state.openingDateEnd,
            createdDateStart: this.state.createdDateStart,
            createdDateEnd: this.state.createdDateEnd
        };

        if (this.props.isSchedulingMode) {
            request.useReportDateForOpeningDateStart = this.state.useReportDateForOpeningDateStart;
            request.useReportDateForOpeningDateEnd = this.state.useReportDateForOpeningDateEnd;
            request.useReportDateForCreatedDateStart = this.state.useReportDateForCreatedDateStart;
            request.useReportDateForCreatedDateEnd = this.state.useReportDateForCreatedDateEnd;
        }

        return {
            apiRequest: request,
            formValues: this.state
        };
    }

    onFieldChange = (name, value) => {
        this.setState({ ...this.state, [name]: value });
    }

    onDropdownChange = (value, name) => {
        this.onFieldChange(name, value);
    }

    onDatePickerChange = (date, name) => {
        this.onFieldChange(name, date);
    }

    render() {
        return (
            <form id="subForm" noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="isLocationActive"
                            label="Location Status" idField="id" valueField="name"
                            options={this.state.locationStatusOptions}
                            selectedValues={this.state.isLocationActive.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            isMulti={false} />
                    </div>
                    <div className="col-sm-12 col-md-2">
                        <DatePicker showIcon name="openingDateStart"
                            value={this.state.openingDateStart}
                            label="Opening Range From"
                            onChange={this.onDatePickerChange} />
                    </div>
                    <div className="col-sm-12 col-md-2">
                        <DatePicker showIcon name="openingDateEnd"
                            value={this.state.openingDateEnd}
                            label="To"
                            onChange={this.onDatePickerChange} />
                    </div>
                    <div className="col-sm-12 col-md-2">
                        <DatePicker showIcon name="createdDateStart"
                            value={this.state.createdDateStart}
                            label="Created Date From"
                            onChange={this.onDatePickerChange} />
                    </div>
                    <div className="col-sm-12 col-md-2">
                        <DatePicker showIcon name="createdDateEnd"
                            value={this.state.createdDateEnd}
                            label="To"
                            onChange={this.onDatePickerChange} />
                    </div>
                </div>
                {
                    this.props.isSchedulingMode &&
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                        </div>
                        <div className="col-sm-12 col-md-2">
                            <Toggle name="useReportDateForOpeningDateStart"
                                text="Substitute Current Date for Beginning Opening Date"
                                checked={this.state.useReportDateForOpeningDateStart}
                                onChange={this.onFieldChange} />
                        </div>
                        <div className="col-sm-12 col-md-2">
                            <Toggle name="useReportDateForOpeningDateEnd"
                                text="Substitute Current Date for Ending Opening Date"
                                checked={this.state.useReportDateForOpeningDateEnd}
                                onChange={this.onFieldChange} />
                        </div>
                        <div className="col-sm-12 col-md-2">
                            <Toggle name="useReportDateForCreatedDateStart"
                                text="Substitute Current Date for Beginning Created Date"
                                checked={this.state.useReportDateForCreatedDateStart}
                                onChange={this.onFieldChange} />
                        </div>
                        <div className="col-sm-12 col-md-2">
                            <Toggle name="useReportDateForCreatedDateEnd"
                                text="Substitute Current Date for Ending Created Date"
                                checked={this.state.useReportDateForCreatedDateEnd}
                                onChange={this.onFieldChange} />
                        </div>
                    </div>
                }
            </form>
        );
    }
}

LocationListFilters.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object,
    isFormValid: PropTypes.bool.isRequired,
    registerReportFilterFunctions: PropTypes.func.isRequired,
    urlParams: PropTypes.object.isRequired,
    savedFilterValues: PropTypes.object.isRequired,
    isSchedulingMode: PropTypes.bool,
};

export default LocationListFilters;
